import { ResourceModel } from "src/app/core/models/resource.model";

export class User extends ResourceModel<User> {
    id!: string;
    email!: string;
    username!: string;
    isLoggedIn!: boolean;
    roles_list!: Array<any>;
    groups!:Array<any>;
}